// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={293}
    height={198}
    viewBox="0 0 293 198"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      x1={192.597}
      y1={113.05}
      x2={198.179}
      y2={104.181}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <line
      x1={95.8482}
      y1={138.16}
      x2={70.8482}
      y2={135.16}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <line
      x1={94.9872}
      y1={144.157}
      x2={83.9872}
      y2={146.156}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <line
      x1={195.334}
      y1={68.0042}
      x2={211.493}
      y2={40.2208}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <path
      d="M141.2 72.0376C156.695 54.4291 139.13 40.1674 139.13 40.1674"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <path
      d="M143.212 57.8452C146.007 49.5225 137.09 42.7381 137.09 42.7381"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <line
      x1={195.558}
      y1={116.737}
      x2={217.754}
      y2={102.868}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <line
      x1={217.96}
      y1={153.235}
      x2={243.798}
      y2={156.358}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <g filter="url(#filter0_d_949_12070)">
      <mask
        id="path-9-inside-1_949_12070"
        fill="white"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M194.919 135.778H197.897V143.95H197.895C197.795 156.615 176.82 166.867 150.959 166.867C125.037 166.867 104.023 156.566 104.023 143.859C104.023 143.584 104.033 143.31 104.052 143.038V135.778H106.999C113.674 127.057 130.838 120.85 150.959 120.85C171.081 120.85 188.245 127.057 194.919 135.778Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.919 135.778H197.897V143.95H197.895C197.795 156.615 176.82 166.867 150.959 166.867C125.037 166.867 104.023 156.566 104.023 143.859C104.023 143.584 104.033 143.31 104.052 143.038V135.778H106.999C113.674 127.057 130.838 120.85 150.959 120.85C171.081 120.85 188.245 127.057 194.919 135.778Z"
        fill="#9B9AA2"
      />
      <path
        d="M194.919 135.778L194.178 136.345L194.458 136.711H194.919V135.778ZM197.897 135.778H198.83V134.845H197.897V135.778ZM197.897 143.95V144.883H198.83V143.95H197.897ZM197.895 143.95V143.016H196.969L196.962 143.942L197.895 143.95ZM104.052 143.038L104.983 143.105L104.986 143.071V143.038H104.052ZM104.052 135.778V134.845H103.119V135.778H104.052ZM106.999 135.778V136.711H107.46L107.74 136.345L106.999 135.778ZM194.919 136.711H197.897V134.845H194.919V136.711ZM196.963 135.778V143.95H198.83V135.778H196.963ZM197.897 143.016H197.895V144.883H197.897V143.016ZM196.962 143.942C196.916 149.725 192.075 155.218 183.678 159.319C175.342 163.391 163.779 165.934 150.959 165.934V167.8C164 167.8 175.855 165.217 184.497 160.997C193.078 156.805 198.774 150.84 198.828 143.957L196.962 143.942ZM150.959 165.934C138.109 165.934 126.521 163.379 118.181 159.29C109.779 155.172 104.956 149.659 104.956 143.859H103.09C103.09 150.766 108.773 156.757 117.359 160.966C126.007 165.205 137.887 167.8 150.959 167.8V165.934ZM104.956 143.859C104.956 143.606 104.965 143.355 104.983 143.105L103.121 142.971C103.1 143.266 103.09 143.562 103.09 143.859H104.956ZM104.986 143.038V135.778H103.119V143.038H104.986ZM104.052 136.711H106.999V134.845H104.052V136.711ZM107.74 136.345C110.923 132.187 116.691 128.536 124.242 125.926C131.773 123.322 140.99 121.783 150.959 121.783V119.917C140.807 119.917 131.381 121.482 123.632 124.162C115.902 126.834 109.75 130.648 106.258 135.211L107.74 136.345ZM150.959 121.783C160.929 121.783 170.146 123.322 177.677 125.926C185.228 128.536 190.996 132.187 194.178 136.345L195.66 135.211C192.168 130.648 186.017 126.834 178.287 124.162C170.537 121.482 161.111 119.917 150.959 119.917V121.783Z"
        fill="#29292F"
        mask="url(#path-9-inside-1_949_12070)"
      />
      <path
        d="M197.429 135.776C197.429 141.852 192.39 147.485 183.943 151.626C175.526 155.752 163.865 158.318 150.959 158.318C138.054 158.318 126.393 155.752 117.976 151.626C109.528 147.485 104.49 141.852 104.49 135.776C104.49 129.699 109.528 124.066 117.976 119.925C126.393 115.799 138.054 113.234 150.959 113.234C163.865 113.234 175.526 115.799 183.943 119.925C192.39 124.066 197.429 129.699 197.429 135.776Z"
        fill="#E4E3E7"
        stroke="#29292F"
        strokeWidth={0.933261}
      />
    </g>
    <mask
      id="path-12-inside-2_949_12070"
      fill="white"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.927 132.624C119.925 132.697 119.924 132.769 119.924 132.842C119.924 141.244 133.818 148.055 150.958 148.055C168.098 148.055 181.993 141.244 181.993 132.842C181.993 132.769 181.992 132.697 181.99 132.624H181.993V118.391L160.686 118.391C157.626 117.896 154.356 117.628 150.958 117.628C147.56 117.628 144.29 117.896 141.23 118.391L119.924 118.391V132.624H119.927Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.927 132.624C119.925 132.697 119.924 132.769 119.924 132.842C119.924 141.244 133.818 148.055 150.958 148.055C168.098 148.055 181.993 141.244 181.993 132.842C181.993 132.769 181.992 132.697 181.99 132.624H181.993V118.391L160.686 118.391C157.626 117.896 154.356 117.628 150.958 117.628C147.56 117.628 144.29 117.896 141.23 118.391L119.924 118.391V132.624H119.927Z"
      fill="#F95396"
    />
    <path
      d="M119.927 132.624L120.86 132.651L120.887 131.691H119.927V132.624ZM150.958 148.055V148.988V148.055ZM181.99 132.624V131.691H181.029L181.057 132.651L181.99 132.624ZM181.993 132.624V133.558H182.926V132.624H181.993ZM181.993 118.391H182.926V117.458L181.993 117.458V118.391ZM160.686 118.391L160.537 119.312L160.611 119.324L160.686 119.324V118.391ZM150.958 117.628V118.562V117.628ZM141.23 118.391V119.324H141.305L141.379 119.312L141.23 118.391ZM119.924 118.391L119.924 117.458L118.991 117.458V118.391H119.924ZM119.924 132.624H118.991V133.558H119.924V132.624ZM120.857 132.842C120.857 132.778 120.858 132.715 120.86 132.651L118.994 132.598C118.992 132.679 118.991 132.76 118.991 132.842H120.857ZM150.958 147.122C142.499 147.122 134.887 145.439 129.424 142.761C123.9 140.053 120.857 136.489 120.857 132.842H118.991C118.991 137.596 122.894 141.639 128.603 144.437C134.372 147.265 142.277 148.988 150.958 148.988V147.122ZM181.059 132.842C181.059 136.489 178.016 140.053 172.492 142.761C167.029 145.439 159.417 147.122 150.958 147.122V148.988C159.639 148.988 167.544 147.265 173.314 144.437C179.022 141.639 182.926 137.596 182.926 132.842H181.059ZM181.057 132.651C181.058 132.715 181.059 132.778 181.059 132.842H182.926C182.926 132.76 182.925 132.679 182.922 132.598L181.057 132.651ZM181.993 131.691H181.99V133.558H181.993V131.691ZM181.059 118.391V132.624H182.926V118.391H181.059ZM160.686 119.324L181.993 119.324V117.458L160.686 117.458V119.324ZM150.958 118.562C154.308 118.562 157.528 118.826 160.537 119.312L160.835 117.469C157.725 116.967 154.405 116.695 150.958 116.695V118.562ZM141.379 119.312C144.389 118.826 147.609 118.562 150.958 118.562V116.695C147.512 116.695 144.192 116.967 141.081 117.469L141.379 119.312ZM119.924 119.324L141.23 119.324V117.458L119.924 117.458L119.924 119.324ZM120.857 132.624V118.391H118.991V132.624H120.857ZM119.927 131.691H119.924V133.558H119.927V131.691Z"
      fill="#29292F"
      mask="url(#path-12-inside-2_949_12070)"
    />
    <ellipse
      cx={150.96}
      cy={118.437}
      rx={31.0344}
      ry={15.2133}
      fill="#FF73A9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.675 115.098C123.78 108.302 136.16 103.224 150.96 103.224C165.759 103.224 178.139 108.302 181.244 115.098C178.139 121.894 165.759 126.972 150.96 126.972C136.16 126.972 123.78 121.894 120.675 115.098Z"
      fill="#FF9DBE"
    />
    <path
      d="M141.873 110.754C141.743 110.188 142.687 109.855 143.723 110.101L160.959 114.2C162.175 114.489 162.599 115.336 161.694 115.666L146.672 121.153C145.754 121.488 144.243 121.012 144.087 120.339L141.873 110.754Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={1.18618}
    />
    <path
      d="M181.527 118.437C181.527 122.362 178.269 126.045 172.699 128.776C167.16 131.491 159.474 133.184 150.96 133.184C142.445 133.184 134.76 131.491 129.22 128.776C123.65 126.045 120.392 122.362 120.392 118.437C120.392 114.513 123.65 110.829 129.22 108.099C134.76 105.384 142.445 103.691 150.96 103.691C159.474 103.691 167.16 105.384 172.699 108.099C178.269 110.829 181.527 114.513 181.527 118.437Z"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <path
      d="M100.097 107.497L100.043 107.452C101.145 106.432 101.797 105.016 101.855 103.517C101.914 102.018 101.374 100.557 100.355 99.4568L100.405 99.4022C100.901 99.95 101.501 100.394 102.17 100.709C102.838 101.024 103.563 101.203 104.302 101.236C105.04 101.269 105.778 101.156 106.473 100.902C107.168 100.649 107.806 100.26 108.351 99.7593C106.09 101.853 105.606 105.029 107.992 107.605L107.92 107.661C105.77 105.76 102.25 105.504 100.097 107.497Z"
      fill="#FCFBF7"
    />
    <path
      d="M99.6174 107.46L99.8506 107.244C100.896 106.274 101.515 104.93 101.571 103.505C101.626 102.081 101.114 100.693 100.147 99.6472L99.9706 99.4566L100.404 98.9859L100.611 99.2095C101.57 100.258 102.906 100.885 104.326 100.954C105.026 100.989 105.726 100.883 106.384 100.642C107.043 100.401 107.646 100.03 108.158 99.5517L108.541 99.9645L108.54 99.965C106.6 101.762 105.747 104.77 108.198 107.413L108.407 107.64L107.906 108.024L107.732 107.871C105.581 105.968 102.241 105.893 100.287 107.703L100.103 107.873L99.6174 107.46ZM101.533 100.68C101.97 101.574 102.175 102.564 102.131 103.558C102.087 104.552 101.795 105.52 101.281 106.373C102.175 105.982 103.147 105.8 104.122 105.842C105.097 105.884 106.05 106.148 106.906 106.614C106.4 105.768 106.136 104.798 106.145 103.81C106.153 102.823 106.433 101.857 106.954 101.018C106.12 101.391 105.21 101.562 104.299 101.517C103.322 101.471 102.371 101.183 101.533 100.68Z"
      fill="#29292F"
    />
    <path
      d="M175.252 82.1189L175.193 82.0983C175.781 80.9008 175.868 79.5196 175.437 78.2586C175.006 76.9977 174.091 75.9602 172.895 75.3745L172.919 75.3131C173.505 75.6084 174.144 75.7846 174.8 75.8315C175.455 75.8784 176.113 75.795 176.736 75.5863C177.359 75.3775 177.935 75.0475 178.43 74.6152C178.925 74.1829 179.33 73.6569 179.621 73.0676L179.698 73.0925C178.493 75.5503 178.989 78.3808 181.791 79.7521C179.401 78.8645 176.4 79.7785 175.252 82.1189Z"
      fill="#FCFBF7"
    />
    <path
      d="M174.801 82.26L174.941 81.9742C175.494 80.8435 175.576 79.5402 175.169 78.3502C174.762 77.1602 173.9 76.1808 172.771 75.6269L172.538 75.5129L172.769 74.9255L173.043 75.0597C174.167 75.6176 175.466 75.7094 176.658 75.3153C177.245 75.1216 177.788 74.8118 178.254 74.4043C178.719 73.9968 179.098 73.5 179.368 72.9433L179.476 72.7237L180.094 72.924L179.951 73.2157C179.381 74.3039 179.226 75.5616 179.514 76.7548C179.69 77.3596 179.996 77.9184 180.411 78.3923C180.826 78.8663 181.34 79.2438 181.916 79.4986L181.693 80.0157C179.316 79.133 176.54 80.1319 175.506 82.2421L175.396 82.466L174.801 82.26ZM174.367 76.0646C174.98 76.6582 175.442 77.3906 175.713 78.2001C175.983 79.0097 176.056 79.8726 175.924 80.7164C176.513 80.1537 177.215 79.7232 177.984 79.4535C178.752 79.1839 179.569 79.0814 180.38 79.153C179.699 78.5582 179.209 77.7759 178.971 76.9038C178.77 76.1392 178.747 75.3386 178.905 74.5636C178.327 75.1508 177.617 75.5917 176.835 75.8497C176.038 76.1149 175.19 76.1865 174.361 76.0586L174.367 76.0646Z"
      fill="#29292F"
    />
    <path
      d="M50.9872 172.224L51.1273 171.938C51.6803 170.807 51.7624 169.504 51.3556 168.314C50.9487 167.124 50.0862 166.144 48.9573 165.591L48.7243 165.477L48.9555 164.889L49.2297 165.023C50.3534 165.581 51.6523 165.673 52.8444 165.279C53.4319 165.085 53.9746 164.775 54.4402 164.368C54.9058 163.96 55.2849 163.464 55.5548 162.907L55.6624 162.687L56.2805 162.888L56.1376 163.179C55.5677 164.267 55.4123 165.525 55.7004 166.718C55.8767 167.323 56.183 167.882 56.5978 168.356C57.0127 168.83 57.5261 169.207 58.1021 169.462L57.8798 169.979C55.5023 169.097 52.7267 170.095 51.6922 172.206L51.5824 172.43L50.9872 172.224ZM50.5536 166.028C51.1667 166.622 51.6282 167.354 51.899 168.164C52.1699 168.973 52.2423 169.836 52.1102 170.68C52.6993 170.117 53.4016 169.687 54.1701 169.417C54.9386 169.148 55.7557 169.045 56.5666 169.117C55.886 168.522 55.3957 167.74 55.1571 166.867C54.9562 166.103 54.9337 165.302 55.0912 164.527C54.5132 165.114 53.8036 165.555 53.0213 165.813C52.2247 166.079 51.3767 166.15 50.5474 166.022L50.5536 166.028Z"
      fill="#29292F"
    />
    <path
      d="M204.936 128.777L204.901 128.754C205.482 128.069 205.766 127.181 205.693 126.286C205.619 125.392 205.193 124.563 204.508 123.983L204.533 123.947C204.868 124.237 205.256 124.457 205.676 124.596C206.097 124.735 206.54 124.789 206.982 124.755C207.423 124.721 207.853 124.601 208.248 124.4C208.643 124.199 208.994 123.922 209.281 123.585L209.327 123.614C208.135 125.021 207.993 126.952 209.597 128.309C208.182 127.335 206.071 127.438 204.936 128.777Z"
      fill="#FCFBF7"
    />
    <path
      d="M204.662 128.823L204.801 128.66C205.349 128.012 205.617 127.175 205.548 126.33C205.478 125.486 205.076 124.704 204.43 124.156L204.297 124.043L204.544 123.698L204.701 123.831C205.343 124.38 206.177 124.654 207.02 124.593C207.436 124.564 207.841 124.451 208.213 124.261C208.584 124.072 208.913 123.81 209.181 123.491L209.288 123.365L209.659 123.598L209.517 123.765C208.966 124.382 208.657 125.178 208.648 126.004C208.664 126.428 208.772 126.844 208.965 127.222C209.157 127.6 209.43 127.931 209.765 128.192L209.534 128.493C208.127 127.525 206.149 127.72 205.126 128.928L205.017 129.056L204.662 128.823ZM205.4 124.705C205.703 125.194 205.884 125.748 205.927 126.322C205.971 126.895 205.876 127.471 205.65 128C206.128 127.73 206.658 127.564 207.204 127.515C207.75 127.465 208.301 127.533 208.819 127.714C208.472 127.213 208.281 126.621 208.269 126.012C208.264 125.48 208.381 124.953 208.612 124.473C208.137 124.761 207.601 124.932 207.048 124.972C206.484 125.014 205.918 124.921 205.397 124.7L205.4 124.705Z"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.196476}
    />
    <path
      d="M91.5482 157.672L91.513 157.649C92.0938 156.964 92.3787 156.076 92.305 155.182C92.2313 154.287 91.805 153.458 91.1198 152.879L91.1457 152.843C91.4801 153.132 91.8686 153.353 92.2888 153.491C92.7089 153.63 93.1525 153.684 93.5939 153.65C94.0353 153.617 94.4657 153.496 94.8604 153.295C95.255 153.094 95.6061 152.818 95.8933 152.481L95.9395 152.51C94.7473 153.916 94.605 155.847 96.209 157.204C94.7939 156.231 92.6834 156.333 91.5482 157.672Z"
      fill="#FCFBF7"
    />
    <path
      d="M91.2289 157.689L91.3676 157.526C91.9151 156.878 92.1835 156.041 92.114 155.196C92.0444 154.352 91.6425 153.57 90.9964 153.022L90.863 152.909L91.1109 152.564L91.2679 152.697C91.9098 153.246 92.743 153.52 93.5866 153.459C94.0022 153.43 94.4078 153.317 94.7791 153.127C95.1504 152.938 95.4798 152.676 95.7479 152.357L95.8544 152.231L96.225 152.464L96.0836 152.631C95.532 153.248 95.2232 154.044 95.2147 154.87C95.2302 155.294 95.3381 155.71 95.531 156.088C95.7238 156.466 95.9969 156.797 96.3311 157.058L96.1007 157.359C94.6934 156.391 92.7158 156.586 91.6923 157.794L91.5837 157.922L91.2289 157.689ZM91.9669 153.571C92.2695 154.06 92.4502 154.614 92.4937 155.188C92.5372 155.761 92.4422 156.337 92.2168 156.866C92.6943 156.596 93.224 156.43 93.7704 156.381C94.3168 156.331 94.8673 156.399 95.3852 156.579C95.0387 156.079 94.8474 155.487 94.8353 154.878C94.8301 154.346 94.9474 153.819 95.178 153.339C94.7037 153.627 94.1675 153.798 93.6141 153.838C93.0501 153.88 92.4844 153.787 91.9638 153.566L91.9669 153.571Z"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.196476}
    />
    <path
      d="M39.3823 106.612L39.3614 106.575C40.19 106.228 40.8466 105.566 41.1868 104.736C41.5269 103.905 41.5228 102.973 41.1753 102.146L41.2147 102.125C41.3813 102.535 41.6275 102.908 41.9391 103.222C42.2507 103.536 42.6215 103.785 43.0301 103.956C43.4387 104.126 43.877 104.214 44.3198 104.214C44.7626 104.214 45.201 104.127 45.6098 103.957L45.6378 104.003C43.9373 104.716 42.9346 106.372 43.7483 108.309C42.9289 106.8 41.0016 105.933 39.3823 106.612Z"
      fill="#FCFBF7"
    />
    <path
      d="M39.0903 106.482L39.2881 106.399C40.0697 106.07 40.689 105.446 41.01 104.662C41.331 103.878 41.3275 102.999 41.0003 102.217L40.9327 102.056L41.3103 101.861L41.3899 102.05C41.7127 102.831 42.3309 103.453 43.1103 103.782C43.4942 103.944 43.9068 104.027 44.3236 104.027C44.7404 104.027 45.1529 103.943 45.5365 103.78L45.6885 103.716L45.9132 104.092L45.7115 104.176C44.9401 104.476 44.3038 105.045 43.9211 105.778C43.7426 106.163 43.6503 106.582 43.6507 107.006C43.6511 107.431 43.7442 107.85 43.9235 108.234L43.5815 108.398C42.7667 106.897 40.9159 106.173 39.4559 106.785L39.301 106.85L39.0903 106.482ZM41.6161 103.147C41.6641 103.72 41.5736 104.296 41.3522 104.826C41.1308 105.357 40.7851 105.827 40.3441 106.196C40.8923 106.172 41.4394 106.265 41.9488 106.469C42.4581 106.673 42.918 106.983 43.2977 107.378C43.2161 106.775 43.3141 106.161 43.5795 105.613C43.8164 105.136 44.1598 104.72 44.5832 104.396C44.0298 104.438 43.4744 104.347 42.9632 104.131C42.4416 103.913 41.9796 103.573 41.6156 103.141L41.6161 103.147Z"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.196476}
    />
    <path
      d="M212.264 91.697L212.243 91.6604C213.071 91.3131 213.728 90.6513 214.068 89.8206C214.408 88.9898 214.404 88.0582 214.057 87.2307L214.096 87.2102C214.263 87.62 214.509 87.9927 214.82 88.3068C215.132 88.621 215.503 88.8704 215.911 89.0406C216.32 89.2109 216.758 89.2986 217.201 89.2987C217.644 89.2989 218.082 89.2115 218.491 89.0415L218.519 89.0882C216.819 89.801 215.816 91.4569 216.63 93.3943C215.81 91.8845 213.883 91.0183 212.264 91.697Z"
      fill="#FCFBF7"
    />
    <path
      d="M211.977 91.8723L212.174 91.7895C212.956 91.461 213.575 90.8362 213.896 90.0522C214.217 89.2682 214.214 88.3891 213.887 87.6078L213.819 87.4467L214.197 87.2512L214.276 87.4408C214.599 88.2218 215.217 88.8441 215.997 89.1725C216.38 89.3346 216.793 89.418 217.21 89.4176C217.627 89.4173 218.039 89.3332 218.423 89.1704L218.575 89.1067L218.799 89.4823L218.598 89.5669C217.826 89.8664 217.19 90.4355 216.807 91.1685C216.629 91.5535 216.536 91.9727 216.537 92.397C216.537 92.8212 216.63 93.2403 216.81 93.6248L216.468 93.7886C215.653 92.2872 213.802 91.5637 212.342 92.1757L212.187 92.2407L211.977 91.8723ZM214.502 88.5374C214.55 89.1102 214.46 89.6863 214.238 90.217C214.017 90.7477 213.671 91.2175 213.23 91.587C213.779 91.5627 214.326 91.6555 214.835 91.8593C215.344 92.0632 215.804 92.3733 216.184 92.769C216.102 92.1656 216.2 91.5515 216.466 91.0033C216.703 90.5264 217.046 90.1103 217.469 89.7869C216.916 89.8287 216.361 89.7379 215.849 89.522C215.328 89.3035 214.866 88.964 214.502 88.5316L214.502 88.5374Z"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.196476}
    />
    <path
      d="M255.336 120.411L255.315 120.374C256.144 120.027 256.8 119.365 257.14 118.534C257.481 117.704 257.476 116.772 257.129 115.945L257.168 115.924C257.335 116.334 257.581 116.707 257.893 117.021C258.204 117.335 258.575 117.584 258.984 117.754C259.392 117.925 259.831 118.012 260.273 118.013C260.716 118.013 261.155 117.925 261.563 117.755L261.591 117.802C259.891 118.515 258.888 120.171 259.702 122.108C258.882 120.598 256.955 119.732 255.336 120.411Z"
      fill="#FCFBF7"
    />
    <path
      d="M255.049 120.587L255.247 120.504C256.028 120.176 256.647 119.551 256.969 118.767C257.29 117.983 257.286 117.104 256.959 116.323L256.891 116.162L257.269 115.966L257.348 116.156C257.671 116.937 258.289 117.559 259.069 117.887C259.453 118.049 259.865 118.133 260.282 118.132C260.699 118.132 261.111 118.048 261.495 117.885L261.647 117.822L261.872 118.197L261.67 118.282C260.899 118.581 260.262 119.15 259.88 119.883C259.701 120.268 259.609 120.688 259.609 121.112C259.61 121.536 259.703 121.955 259.882 122.34L259.54 122.503C258.725 121.002 256.874 120.279 255.414 120.891L255.259 120.956L255.049 120.587ZM257.575 117.252C257.623 117.825 257.532 118.401 257.311 118.932C257.089 119.463 256.744 119.932 256.303 120.302C256.851 120.278 257.398 120.37 257.907 120.574C258.417 120.778 258.877 121.088 259.256 121.484C259.175 120.88 259.273 120.266 259.538 119.718C259.775 119.241 260.118 118.825 260.542 118.502C259.988 118.544 259.433 118.453 258.922 118.237C258.4 118.018 257.938 117.679 257.574 117.246L257.575 117.252Z"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.196476}
    />
    <rect
      x={125.97}
      y={24.9488}
      width={11.7182}
      height={11.3802}
      rx={3.54439}
      transform="rotate(42.2152 125.97 24.9488)"
      fill="#ABE3FF"
      stroke="#29292F"
      strokeWidth={0.936255}
    />
    <rect
      x={79.6754}
      y={109.129}
      width={8.55344}
      height={8.29997}
      rx={3.54439}
      transform="rotate(135 79.6754 109.129)"
      fill="#E1DBFF"
      stroke="#29292F"
      strokeWidth={0.936255}
    />
    <path
      d="M215.532 18.8999L218.286 28.1827L223.726 22.5614L238.339 1.00042L215.532 18.8999Z"
      fill="#75F5C4"
      stroke="#29292F"
      strokeWidth={0.934104}
      strokeLinejoin="bevel"
    />
    <path
      d="M238.338 1.00294L205.944 14.6177L215.532 18.9024L238.338 1.00294Z"
      fill="#C8FBE7"
      stroke="#29292F"
      strokeWidth={0.934104}
      strokeLinejoin="round"
    />
    <path
      d="M238.339 1.00014L229.915 25.3271L220.327 21.0424L238.339 1.00014Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.934104}
      strokeLinejoin="round"
    />
    <path
      d="M223.725 22.5668L218.287 28.188L220.327 21.048L223.725 22.5668Z"
      fill="#38D695"
      stroke="#29292F"
      strokeWidth={0.934104}
      strokeLinejoin="bevel"
    />
    <circle
      cx={275.871}
      cy={69.6659}
      r={10.0954}
      transform="rotate(-7.37202 275.871 69.6659)"
      fill="#FFD5E1"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <path
      d="M279.49 68.6282C280.181 68.9164 280.301 69.8449 279.706 70.2996L274.87 73.9934C274.275 74.4481 273.411 74.0878 273.314 73.345L272.534 67.3098C272.437 66.5669 273.182 65.9986 273.873 66.2868L279.49 68.6282Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <circle
      cx={13.8961}
      cy={141.345}
      r={10.0954}
      transform="rotate(-67.185 13.8961 141.345)"
      fill="#C8FBE7"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <path
      d="M19.2966 144.85L19.7031 144.722L19.6136 144.306L19.3762 143.201L19.376 143.2L19.3738 143.19C18.9602 141.246 18.6062 139.583 18.1144 138.271C17.6188 136.949 16.9583 135.913 15.8857 135.289C14.1216 134.263 11.9323 134.847 10.9095 136.605C10.4224 137.442 10.283 138.437 10.4699 139.351C9.58315 139.641 8.78708 140.254 8.29997 141.091C7.27721 142.849 7.85179 145.041 9.61595 146.067C10.6885 146.691 11.9158 146.753 13.31 146.53C14.6935 146.309 16.3141 145.795 18.2079 145.194L18.2183 145.19L18.2191 145.19L19.2966 144.85Z"
      fill="#75F5C4"
      stroke="#29292F"
      strokeWidth={0.936216}
    />
    <line
      x1={58.4}
      y1={84.8417}
      x2={39.123}
      y2={71.8635}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <line
      x1={66.5192}
      y1={80.328}
      x2={47.2421}
      y2={67.3498}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <circle
      cx={31.9771}
      cy={60.3117}
      r={12.1096}
      transform="rotate(-41.0498 31.9771 60.3117)"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <circle
      cx={27.3701}
      cy={62.3451}
      r={1.34997}
      transform="rotate(-41.0498 27.3701 62.3451)"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.285333}
    />
    <circle
      cx={34.623}
      cy={56.0287}
      r={1.34997}
      transform="rotate(-41.0498 34.623 56.0287)"
      fill="#29292F"
      stroke="#29292F"
      strokeWidth={0.285333}
    />
    <circle
      cx={28.7494}
      cy={65.9122}
      r={1.13854}
      transform="rotate(-41.0498 28.7494 65.9122)"
      fill="#FFB743"
    />
    <circle
      cx={37.9691}
      cy={57.8848}
      r={1.13854}
      transform="rotate(-41.0498 37.9691 57.8848)"
      fill="#FFB743"
    />
    <path
      d="M33.9416 59.8825C34.0733 60.0338 34.1693 60.2135 34.2242 60.4114C34.2791 60.6094 34.2917 60.8217 34.2613 61.0362C34.231 61.2507 34.1582 61.4632 34.0473 61.6616C33.9364 61.86 33.7894 62.0404 33.6147 62.1925C33.4401 62.3445 33.2412 62.4654 33.0294 62.548C32.8177 62.6306 32.5972 62.6734 32.3805 62.674C32.1639 62.6746 31.9554 62.6329 31.7668 62.5514C31.5783 62.4698 31.4135 62.35 31.2817 62.1987"
      stroke="#29292F"
      strokeWidth={0.933261}
      strokeLinecap="round"
    />
    <line
      x1={71.7985}
      y1={89.8016}
      x2={52.5214}
      y2={76.8234}
      stroke="#29292F"
      strokeWidth={0.933261}
    />
    <path
      d="M269.619 153.297C269.718 152.484 270.622 152.043 271.323 152.466L274.212 154.21C274.452 154.355 274.737 154.405 275.013 154.351L278.323 153.7C279.127 153.543 279.826 154.266 279.64 155.064L278.874 158.35C278.811 158.623 278.851 158.91 278.988 159.155L280.629 162.103C281.028 162.819 280.556 163.707 279.74 163.777L276.378 164.064C276.098 164.088 275.838 164.215 275.647 164.42L273.351 166.893C272.794 167.493 271.803 167.318 271.484 166.564L270.172 163.455C270.063 163.197 269.862 162.988 269.607 162.87L266.546 161.451C265.803 161.106 265.663 160.11 266.282 159.573L268.833 157.365C269.045 157.182 269.182 156.926 269.215 156.647L269.619 153.297Z"
      fill="#FFD074"
    />
    <path
      d="M271.565 152.066C270.573 151.467 269.293 152.091 269.155 153.241L268.75 156.591C268.731 156.754 268.651 156.904 268.527 157.011L265.976 159.22C265.1 159.978 265.298 161.388 266.349 161.875L269.41 163.295C269.559 163.364 269.677 163.486 269.741 163.637L271.053 166.746C271.503 167.813 272.905 168.06 273.694 167.211L275.99 164.739C276.102 164.619 276.254 164.544 276.418 164.53L279.779 164.243C280.934 164.145 281.602 162.888 281.038 161.875L279.397 158.928C279.317 158.784 279.293 158.616 279.33 158.456L280.096 155.17C280.359 154.042 279.37 153.018 278.233 153.241L274.922 153.892C274.761 153.923 274.594 153.894 274.454 153.809L271.565 152.066Z"
      stroke="#29292F"
      strokeWidth={0.936255}
    />
    <path
      d="M271.165 155.63C271.223 155.154 271.752 154.896 272.163 155.143L273.696 156.069C274.035 156.274 274.439 156.345 274.829 156.268L276.586 155.923C277.056 155.831 277.465 156.254 277.356 156.721L276.95 158.465L277.406 158.571L276.95 158.465C276.86 158.852 276.917 159.258 277.11 159.604L277.982 161.169C278.215 161.588 277.938 162.107 277.461 162.148L275.677 162.301C275.281 162.334 274.912 162.514 274.642 162.805L273.424 164.117C273.098 164.469 272.518 164.366 272.331 163.925L271.635 162.275C271.481 161.909 271.196 161.614 270.836 161.447L269.211 160.694C268.777 160.492 268.695 159.909 269.057 159.595L270.411 158.423C270.711 158.164 270.903 157.801 270.951 157.407L271.165 155.63Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeWidth={0.936255}
    />
    <defs>
      <filter
        id="filter0_d_949_12070"
        x={104.023}
        y={112.767}
        width={96.4038}
        height={59.1607}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx={2.53031}
          dy={5.06063}
        />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_949_12070"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_949_12070"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
const SvgGiveADemo = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgGiveADemo;
